import {
  API_URL,
  APPLICATION_IDENTIFIER,
  SUPPORT_API_URL,
} from "@/environment";
import { Api } from "@/packages/common/api";
import { buildAffinityBackendClient } from "@/packages/api/http";
import { usePromoCodeStore } from "@/stores/promoCode";
import { AxiosError } from "axios";
import { reportAffinityApiError } from "@/lib/affinityErrorReporter";

const affinityApiBaseUrl = (API_URL as string).endsWith("/")
  ? `${API_URL}api`
  : `${API_URL}/api`;

export const client = new Api({
  baseURL: affinityApiBaseUrl,
  headers: {
    "X-Application-Identifier": APPLICATION_IDENTIFIER,
    Accept: "application/json",
  },
});

client.api.interceptors.request.use((config) => {
  // If we have a promo code saved, pass it along with _all_ requests to the Affinity backend
  // It helps with analytics between customers.
  const codeStore = usePromoCodeStore();
  const accessCode = codeStore.coupon;

  if (accessCode?.id) {
    config.headers.set("X-Promo-Code-Identifier", accessCode.id);
  }

  return config;
});

client.api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    void reportAffinityApiError(error);
    return Promise.reject(error);
  },
);

export const supportApiClient = new Api({
  baseURL: SUPPORT_API_URL,
  headers: {
    Accept: "application/json",
  },
});

supportApiClient.api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    void reportAffinityApiError(error, "local");
    return Promise.reject(error);
  },
);

export const fetchClient = buildAffinityBackendClient(
  API_URL,
  APPLICATION_IDENTIFIER,
);
